import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import countryReducer from '../features/country/countrySlice';
import loadingReducer from '../features/common/loadingSlice';
import notificationReducer from '../features/common/notificationSlice';
import buttonReducer from '../features/common/buttonStateSlice';
import shufftiProReducer from '../features/shufftiPro/shufftiProSlice';
import freelancerReducer from '../features/freelancer/freelancerSlice';
import userReducer from '../features/adminUsers/adminUserSlice';
import clientReducer from '../features/clients/clientSlice';
import contactPersonReducer from '../features/contactPersons/contactPersonSlice';
import assignmentReducer from '../features/assignments/assignmentSlice';
import packagesReducer from '../features/Packages/packageSlice';
import timeSheetReducer from '../features/timeSheet/timeSheetSlice';
import hoursRegistrationReducer from '../features/HoursRegistration/hoursRegistrationSlice';
import invoiceSlice from '@application/features/invoices/invoiceSlice';
import dashboardSlice from '@application/features/dashboard/dashboardSlice';
import VacancySlice from '@application/features/vacancies/VacancySlice';
import assignmentReasonSlice from '@application/features/assignmentReasons/assignmentReasonSlice';
import placementSlice from '@application/features/placement/placementSlice';
import brokerReducer from '@application/features/brokers/brokerSlice';
import userContractReducer from '@application/features/userContracts/userContractSlice';
import hourRoutingReducer from '@application/features/hourRouting/hourRoutingSlice';
const combinedReducers = combineReducers({
    auth: authReducer,
    country: countryReducer,
    notification: notificationReducer,
    freelancer: freelancerReducer,
    loading: loadingReducer,
    buttonState: buttonReducer,
    user: userReducer,
    client: clientReducer,
    shufftiPro: shufftiProReducer,
    contactPerson: contactPersonReducer,
    assignment: assignmentReducer,
    packages: packagesReducer,
    timeSheet: timeSheetReducer,
    hoursRegistration: hoursRegistrationReducer,
    invoice: invoiceSlice,
    dashboard: dashboardSlice,
    vacancy: VacancySlice,
    assignmentReason: assignmentReasonSlice,
    placement: placementSlice,
    broker: brokerReducer,
    userContract: userContractReducer,
    hourRouting: hourRoutingReducer
});
const rootReducer = (state, action) => {
    if (action.type === 'auth/logout') {
        return combinedReducers(undefined, action);
    }
    return combinedReducers(state, action);
};
export const store = configureStore({
    reducer: rootReducer
});
